import React from 'react';

export default class FloatingHeader extends React.PureComponent {
  render() {
    const { leftChild, rightChild } = this.props;

    return (
      <div className="c-floating__head">
        {leftChild}
        {!leftChild && rightChild && <span />}
        {rightChild}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/FloatingHeader.js